// extracted by mini-css-extract-plugin
export default {"container":"fit-message__container___2DSee","button":"fit-message__button___2XamQ","icon":"fit-message__icon___17pG-","fitment-details":"fit-message__fitment-details___2Mx27"};